import axios from 'axios';
import getSecret from '../getSecret';

const API_BASE = process.env.REACT_APP_AESTHETIC_API_URL || 'https://wimages.salusemr.com';

async function getAuthHeaders() {
  try {
    const { token } = await getSecret('salusemr-token');
    return { Authorization: `Bearer ${token}` };
  } catch {
    return {};
  }
}

async function postFormData(endpoint, formData) {
  const headers = await getAuthHeaders();
  const response = await axios.post(`${API_BASE}${endpoint}`, formData, { headers });
  return response.data;
}

export function analyzeBreastSurgery(formData) {
  return postFormData('/api/aesthetic/breast-surgery-analytics', formData);
}

export function analyzeNose(formData) {
  return postFormData('/api/aesthetic/nose-analysis', formData);
}

export function analyzeJawline(formData) {
  return postFormData('/api/aesthetic/facial-harmony-analysis', formData);
}
